module.exports = __webpack_public_path__ + "media/images/placeholders/play-button-2-cf43c231528d593db9e2c96772497b4b.svg";